module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "homepage"
    }
  }, [_c('div', {
    staticClass: "transition-banner align-middle gradient-background row display-big-screen",
    class: {
      'hidden-banner': _vm.hiddenBanner
    }
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('v-img', {
    attrs: {
      "id": "menu-logo",
      "src": "static/Logo/logo_blancx1.png"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "transition-banner align-middle gradient-background row display-small-screen",
    class: {
      'hidden-banner': _vm.hiddenBanner
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('v-img', {
    attrs: {
      "id": "menu-logo",
      "src": "static/Logo/logo_blancx1.png"
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-9"
  }, [_c('h1', {
    staticClass: "text-left pb-1 times"
  }, [_vm._v("Dr SAAD Ryan")]), _vm._v(" "), _c('h2', [_vm._v("Chirurgien Dentiste qualifié en Chirurgie Orale & Implantologie, PARIS")]), _vm._v(" "), _c('h4', {
    staticClass: "align-center",
    attrs: {
      "id": "homepage-title"
    }
  }, [_vm._v("Votre praticien et toute son équipe vous souhaitent la bienvenue !")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h1', {
    staticClass: "text-left pb-1"
  }, [_vm._v("Dr SAAD Ryan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('h2', [_vm._v("Chirurgien Dentiste qualifié en Chirurgie Orale & Implantologie, PARIS")]), _vm._v(" "), _c('h4', {
    staticClass: "text-left",
    attrs: {
      "id": "homepage-title"
    }
  }, [_vm._v("Votre praticien et toute son équipe vous souhaitent la bienvenue !")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13b8167a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13b8167a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/pages/homepage/homepage.component.html
// module id = 260
// module chunks = 1